module.exports = __webpack_public_path__ + "dashboard/img/up_up.d880761c5d390ee2344bd513b9b5c16a.svg";